import { registerDirectives } from 'nette-base-module/js/directives'

export default function loadDirectives (vueApp, context) {
  const requireContext = require.context(
    // root folder for components
    './',
    // recursive
    true,
    // include all .js wo index.js
    /\/(?!index\.js$)(?:[^.]+)\.js$/,
  )

  return registerDirectives(requireContext, context)
}